import "./CounselingFlow.module.css";
import Header from "@/reusable_sections/Header";
import Flowchart from "./sections/Flowchart";
import Flowdetail from "./sections/Flowdetail";
import Calltoaction from "./sections/Calltoaction";
import Footer from "@/reusable_sections/Footer";
export default function CounselingFlowPage() {
  return <div>
      <Header />
      <Flowchart />
      <Flowdetail />
      <Calltoaction />
      <Footer />
    </div>;
}